var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vbt-error-boundary',{attrs:{"error":_vm.$attrs.error,"no-content":!_vm.orderItems.length}},[_c('vbt-table',{attrs:{"headers":_vm.headers,"items":_vm.orderItems,"show-paginator":""},scopedSlots:_vm._u([{key:"orderId",fn:function(ref){
var orderId = ref.item.orderId;
return [(orderId)?_c('router-link',{staticClass:"info--text",attrs:{"to":{
          name: 'order',
          params: { id: orderId },
          query: { suffix: _vm.suffix },
        }}},[_vm._v(" "+_vm._s(orderId)+" ")]):_vm._e()]}},{key:"uv",fn:function(ref){
        var ref_item = ref.item;
        var uvFront = ref_item.uvFront;
        var uvBack = ref_item.uvBack;
return [_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(uvFront),expression:"uvFront"}]},[_vm._v(" Front: "+_vm._s(uvFront)+" ")]),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(uvBack),expression:"uvBack"}]},[_vm._v(" Back: "+_vm._s(uvBack)+" ")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }